export default __webpack_public_path__ + "static/cafe_36043-bb1aab0569c59dc46e1a0135957dd57d.png";